import { MessageBox, Loading, Message } from 'element-ui'
import axios from 'axios'
import store from '@/store/index'
import I18n, { setup } from '../locales/index'
let loadingInstance
function add () {
  loadingInstance = Loading.service({
    lock: true,
    text: '',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
function remove () {
  loadingInstance.close()
}
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  if (!config.headers.func) {
    config.headers.func = ''
  }
  add()
  return config
}, function (error) {
  Message(I18n.t('neterror'))
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  // 过滤出邮件接口
  if (response.config.url === '/getUserByToken') {
    remove()
    return response
  }
  if (response.config.url === '/selection/brand' ||
      response.config.url === '/selection/model' ||
      response.config.url === '/selection/company' ||
      response.config.url === '/selection/subCompany' ||
      response.config.url === '/user/selection' ||
      response.config.url === '/selection/maintainer') {
    if (response.data && response.data.code === -4) {
      MessageBox.confirm(I18n.t('overtime.overtime'), I18n.t('overtime.tishi'), {
        confirmButtonText: I18n.t('overtime.login')
      }).then(() => {
        remove()
        sessionStorage.clear()
        let clear = store['_mutations'].clearuser[0]
        clear()
        window.location.href = '/'
        setup(0)
      }).catch(() => {
      })
      remove()
      throw new Error()
    } else {
      remove()
      return response
    }
  } else {
    if (response.data && response.data.code === -4) {
      MessageBox.confirm(I18n.t('overtime.overtime'), I18n.t('overtime.tishi'), {
        confirmButtonText: I18n.t('overtime.login')
      }).then(() => {
        remove()
        sessionStorage.clear()
        let clear = store['_mutations'].clearuser[0]
        clear()
        window.location.href = '/'
        setup(0)
      }).catch(() => {
      })
      remove()
    } else {
      remove()
      return response
    }
  }
},
function (error) {
  remove()
  Message(I18n.t('neterror'))
  // 对响应错误做点什么
  return Promise.reject(error)
})

export default {
  get (url, params) {
    return new Promise(function (resolve, reject) {
      let response = axios({
        // baseURL: process.env.VUE_APP_LOGOUT_URL,
        method: 'get',
        url,
        params,
        headers: {
          'func': sessionStorage.getItem('func'),
          'Content-Type': 'application/json;charset=UTF-8;',
          'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
        }
      })
      resolve(response)
    })
  },
  post (url, data) {
    return new Promise(function (resolve, reject) {
      let response = axios({
        // baseURL: process.env.VUE_APP_LOGOUT_URL,
        method: 'post',
        url,
        data,
        headers: {
          'func': sessionStorage.getItem('func'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
        }
      })
      resolve(response)
    })
  },
  postForm (url, data) {
    return new Promise(function (resolve, reject) {
      let response = axios({
        // baseURL: process.env.VUE_APP_LOGOUT_URL,
        method: 'post',
        url,
        data,
        headers: {
          'func': sessionStorage.getItem('func'),
          'Content-Type': 'application/json;charset=UTF-8;',
          'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
        }
      })
      resolve(response)
    })
  },
  // postForm (url) {
  //   return function (params) {
  //     return axios({
  //       baseURL: process.env.VUE_APP_LOGOUT_URL,
  //       method: 'post',
  //       url,
  //       params,
  //       headers: {
  //         'Content-Type': 'application/x-www-form-urlencoded'
  //         // 'Authorization': `Bearer ${localStorage.getItem('access_token')}`
  //       },
  //       transformRequest: [
  //         // 发请求前对data进行处理
  //         data => {
  //           let ret = ''
  //           for (let i in data) {
  //             ret += encodeURIComponent(i) + '=' + encodeURIComponent(data[i]) + '&'
  //           }
  //           return ret
  //         }
  //       ]
  //     }).then((res) => {
  //       return res
  //     }).catch((res) => {
  //     })
  //   }
  // },
  // postFormUpload (url, data) {
  //   return new Promise(function (resolve, reject) {
  //     let response = axios({
  //       baseURL: process.env.VUE_APP_LOGOUT_URL,
  //       method: 'post',
  //       url,
  //       data,
  //       headers: {
  //         'Content-Type': 'multipart/form-data'
  //         // 'Authorization': `Bearer ${localStorage.getItem('access_token')}`
  //       }
  //     })
  //     resolve(response)
  //   })
  // },
  postFormUpload (url) {
    return function (params) {
      return axios({
        // baseURL: process.env.VUE_APP_LOGOUT_URL,
        method: 'post',
        url,
        params,
        headers: {
          'Content-Type': 'multipart/form-data'
          // 'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        }
      }).then((res) => {
        return res
      }).catch((res) => {
      })
    }
  },
  // delete (url, params) {
  //   return new Promise(function (resolve, reject) {
  //     let response = axios({
  //       baseURL: process.env.VUE_APP_LOGOUT_URL,
  //       method: 'delete',
  //       url,
  //       params,
  //       headers: {
  //         'Content-Type': 'application/json;charset=UTF-8;'
  //         // 'Authorization': `Bearer ${localStorage.getItem('access_token')}`
  //       }
  //     })
  //     resolve(response)
  //   })
  // }
  delete (url) {
    return function (params) {
      return axios({
        baseURL: process.env.VUE_APP_LOGOUT_URL,
        method: 'delete',
        url,
        params,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8;'
          // 'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        }
      }).then((res) => {
        return res
      }).catch((res) => {
      })
    }
  }
}
